<!doctype html>
<!-- sonar-ignore-all -->
<html lang="en">
  <head>
    <title>Print BIP</title>
  </head>
  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'></div>
      </div>

      <div style="text-align: center; font-size: 16px">
        <div>
          <b
            >{{ bipLable | reportLabel | async }} for
            {{ printData?.caseData?.student?.firstName }}
            {{ printData?.caseData?.student?.lastName }}</b
          >
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseData?.student?.firstName }}
          {{ printData?.caseData?.student?.lastName }}
        </div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseData?.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <ng-container *ngIf="getSelectedFields().length > 0">
        <div
          *ngFor="let row of getSelectedFields() | chunk: 3"
          data-pdfmake-type="columns">
          <ng-container *ngFor="let field of row; let i = index">
            <div data-pdfmake='{"width":"*"}'>
              <div class="datalabel">{{ field.fieldName }}</div>
              <div class="dataValue">
                <b>{{ getFieldValue(field.fieldName) }}</b>
              </div>
              <br />
            </div>
          </ng-container>
          <!-- If row has only 2 fields, add an empty column for alignment -->
          <ng-container *ngIf="row.length === 2">
            <div data-pdfmake='{"width":"*"}'></div>
          </ng-container>
        </div>
      </ng-container>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div *ngFor="let behavior of printData.caseData.caseBehaviors">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Challenging Behavior: {{ behavior?.behaviorCategoryName }}</b>
            </th>
          </tr>
        </table>
        <br />
        <div
          *ngFor="
            let section of printData.bipTemplate?.templateSections;
            let k = index
          ">
          <div
            *ngIf="isDataAvailable(section, behavior)"
            style="font-size: 18px"
            data-pdfmake='{
          "color": "#128E55"
      }'>
            <b>Section {{ k + 1 }}: {{ section.sectionName }} </b>
          </div>
          <hr
            data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
          <br />
          <ng-container
            *ngIf="section.id === 1 && isDataAvailable(section, behavior)">
            <ng-container
              *ngTemplateOutlet="behaviorTpl; context: { behavior: behavior }">
            </ng-container>
          </ng-container>

          <ng-container
            *ngIf="section.id === 2 && isDataAvailable(section, behavior)">
            <ng-container
              *ngTemplateOutlet="
                strategiesTpl;
                context: { strategies: behavior.caseBehaviorStrategies }
              ">
            </ng-container>
          </ng-container>

          <ng-container
            *ngIf="section.id === 3 && isDataAvailable(section, behavior)">
            <ng-container
              *ngTemplateOutlet="
                customQuestionsTpl;
                context: {
                  customQuestions: behavior.caseBehvaiorCustomQuestionIds,
                }
              "></ng-container>
          </ng-container>

          <ng-container
            *ngIf="section.id === 4 && isDataAvailable(section, behavior)">
            <ng-container *ngTemplateOutlet="reportsTpl"></ng-container>
            <ng-container
              *ngTemplateOutlet="
                reportsTpl;
                context: {
                  reportData: behavior.groupedGraphsAndComments,
                }
              ">
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div data-pdfmake='{"pageBreak": "before"}'>
        <table
          data-pdfmake='{"widths": ["25%", "25%", "25%", "25%"], "heights": 30, "layout": { "hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'>
          <tr>
            <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
              Name
            </th>
            <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
              Title
            </th>
            <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
              Signature
            </th>
            <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
              Date
            </th>
          </tr>
          <tr *ngFor="let item of signatures">
            <td>{{ '' }}</td>
            <td>{{ '' }}</td>
            <td>{{ '' }}</td>
            <td>{{ '' }}</td>
          </tr>
        </table>
      </div>
    </div>
    <ng-template #behaviorTpl let-behavior="behavior">
      <ng-container
        *ngFor="
          let section of printData.caseData.bipTemplateChallengingBehaviors
        ">
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.CaseBehaviorTypes &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Behavior Types:
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{
              behavior?.caseBehaviorTypeIds?.length > 0
                ? behavior?.caseBehaviorTypeIds.join(', ')
                : 'None Selected'
            }}</b>

            <b>{{
              behavior?.caseBehaviorTypeDescriptionIds?.length > 0
                ? ', Other- ' +
                  behavior?.caseBehaviorTypeDescriptionIds.join(', ')
                : ''
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.OperationalDefinition &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Operational Definition:
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ behavior?.operationalDefinition || 'Nothing Entered' }} </b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.Frequency &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Frequency:</div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{
              !!behavior?.behaviourFrequencyId
                ? getFrequencyAnswer(behavior)
                : 'None Selected'
            }}</b>
          </div>
        </div>

        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.Intensity &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Intensity:</div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{
              !!behavior?.behaviourIntensityId
                ? behavior?.behaviourIntensityName
                : 'None Selected'
            }}</b>
          </div>
        </div>

        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.Environmnets &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Environments:
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>
              {{
                behavior?.caseBehaviorEnvironmentIds?.length > 0
                  ? behavior?.caseBehaviorEnvironmentIds.join(', ')
                  : 'None Selected'
              }}
            </b>
          </div>
        </div>

        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.SettingEvents &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Setting Events:
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>
              {{
                behavior?.caseBehaviorSettingEventIds?.length > 0
                  ? behavior?.caseBehaviorSettingEventIds.join(', ')
                  : 'None Selected'
              }}
            </b>
          </div>
        </div>

        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.Antecedents &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Antecedents:</div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>
              {{
                behavior?.caseBehaviorAntecedentIds?.length > 0
                  ? behavior?.caseBehaviorAntecedentIds.join(', ')
                  : 'None Selected'
              }}</b
            >
          </div>
        </div>

        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.Consequences &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Consequences:
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>
              {{
                behavior?.caseBehaviorConsequenceIds?.length > 0
                  ? behavior?.caseBehaviorConsequenceIds.join(', ')
                  : 'None Selected'
              }}
            </b>
            <b>{{
              behavior?.caseBehaviorConsequenceDescriptionIds?.length > 0
                ? ', Other- ' +
                  behavior?.caseBehaviorConsequenceDescriptionIds.join(', ')
                : ''
            }}</b>
          </div>
        </div>

        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            section.applicationObjectId === lookUp_Ids.Goals &&
            section.isSelected
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Goals:</div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b> {{ behavior?.goals || 'Nothing Entered' }}</b>
          </div>
        </div>

        <ng-container *ngIf="section.questionIds.length > 0">
          <div *ngFor="let question of section.questionIds">
            <ng-container
              *ngIf="getQuestionAnswer(behavior, question.questionId) as qa">
              <div
                data-pdfmake='{"margin": [0,0,0,7]}'
                data-pdfmake-type="columns">
                <div data-pdfmake='{"width":175}' class="datalabel">
                  {{ qa.customQuestion }}:
                </div>
                <div data-pdfmake='{"width":"*"}' class="dataValue">
                  <b> {{ qa?.answer || 'Nothing Entered' }}</b>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <br />
    </ng-template>
    <ng-template #strategiesTpl let-strategies="strategies">
      <div *ngFor="let strategy of strategies">
        <div
          style="font-size: 16px"
          data-pdfmake='{
          "color": "#128E55"
      }'>
          <b>
            {{ strategy?.behaviourStrategyTypeName }} > {{ strategy?.title }}</b
          >
        </div>
        <br />
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":70}' class="datalabel">Description:</div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ strategy?.description }} </b>
          </div>
        </div>
        <br />
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":70}' class="datalabel">Details:</div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b> {{ strategy?.details || '-' }} </b>
          </div>
        </div>

        <br />
        <ng-container
          *ngIf="
            printData?.PrintOptions?.isIncludeStrategyGuidelines &&
            strategy?.guidelines?.length > 0
          ">
          <div class="datalabel">Guidelines:</div>
          <br />
          <!--sonar-ignor-start -->
          <table
            data-pdfmake='{"widths": ["*"], "heights": 20,"dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
            <tr>
              <th
                style="display: none"
                data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
                Guidelines
              </th>
            </tr>
            <tr *ngFor="let item of strategy?.guidelines">
              <td
                data-pdfmake='{"margin": [0,3,0,3], "backgroundColor": "transparent"}'
                class="datalabel">
                {{ item?.guideline }}
              </td>
            </tr>
          </table>
          <!--sonar-ignor-end -->
        </ng-container>
        <br />
        <div class="datalabel">Source:</div>
        <br />
        <div class="datalabel">
          {{ strategy?.title }} is an ABA evidence-based intervention provided
          by https://insightstobehavior.com (Accessed:
          {{
            strategy?.strategyModificationDate
              ? (strategy.strategyModificationDate | userDate: 'MM/dd/yyyy')
              : '-'
          }})
        </div>
        <br />
        <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      </div>
    </ng-template>
    <ng-template #customQuestionsTpl let-customQuestions="customQuestions">
      <div *ngFor="let question of customQuestions">
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            {{ question?.customQuestion + ':' }}
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b> {{ question?.answer || 'Nothing Entered' }}</b>
          </div>
        </div>
        <br />
      </div>
    </ng-template>
    <ng-template #reportsTpl let-reportData="reportData">
      <ng-container *ngFor="let data of reportData">
        <div *ngFor="let graphData of data.graphs; let i = index">
          <img
            data-pdfmake='{"width":552}'
            [src]="graphData.graph"
            [alt]="'Chart_' + i"
            class="chartImage" />
          <br />
        </div>
        <div *ngIf="data.commentsData?.length > 0">
          <div class="extraLineHeight">
            <b> Note:</b>
            <hr
              data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
            <br />
          </div>
          <ng-container *ngFor="let commentData of data.commentsData">
            <div
              class="extraLineHeight"
              style="font-size: 16px"
              data-pdfmake='{
                "color": "#128E55"}'>
              <b> Data Date: {{ commentData.dataDate | date: 'MM/dd/yyyy' }}</b>
              <br />
            </div>
            <div *ngFor="let comment of commentData.comments">
              <table
                data-pdfmake='{"widths": ["*"], "heights": 10,"dontBreakRows": true, "layout": { "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
                <thead>
                  <tr>
                    <th style="display: none">Note Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      class="font10"
                      data-pdfmake='{"fillColor": "#F9FAFB","padding": [0,3,0,3]}'>
                      <span class="commentLabel">
                        <b>Note Date: </b>
                        {{ comment.createdOn | userDate: 'MM/dd/yyyy hh:mm a' }}
                        &nbsp;-&nbsp; {{ comment.createdByName }}
                      </span>
                      <br />
                      <span style="color: #101828">{{ comment?.comment }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
          </ng-container>
        </div>
      </ng-container>
    </ng-template>
  </body>
</html>
